// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__1O0TZ","text--wide":"Text_text--wide__3_vNc","title":"Text_title__1NtmQ","description":"Text_description__J_zIj","reduced-opacity":"Text_reduced-opacity__QAUjM"};